import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { Backdrop } from "@mui/material";
import { useHistory } from "react-router-dom";

import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { ReactComponent as UploadIcon } from "assets/img/svg/fi_upload.svg";
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadBlack.svg";

import { putpost } from "services/http";
import ALoader from "views/pages/manage/common/a-loader";
import APopover from "views/pages/manage/common/a-popover";
import { commonMessages, endpoint } from "../../../common/constant";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ConfirmationDialog } from "views/pages/manage/common/commonComponents";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import {
  fetchAllPromisedData,
  fetchAllPostPromisedData,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import DocUploadModal from "views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal";

import Filters from "./Filters";
import TableContent from "./TableContent";
import { DEFAULT_FILTERS } from "./constants";

const DOC_DISPLAY_VALUE = "Bulk School Master";
const SERVICE_NAME = "BULK_SCHOOL_MASTER";

const BulkSchoolUpload = () => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [isUploadDialogOpen, setUploadDialogOpen] = useState(false);

  const [filterCount, setFilterCount] = useState();
  const [globalFilter, setGlobalFilter] = useState(DEFAULT_FILTERS);
  const [fileUploadData, setFileUploadData] = useState({
    bulkUploadS3Key: "",
    fileName: "",
  });

  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    fetchBulkSchoolUploadLog();
  }, []);

  const fetchBulkSchoolUploadLog = async (
    filters = globalFilter,
    page = currentPage
  ) => {
    setIsLoading(true);

    const payload = filters;

    const response = await fetchAllPostPromisedData(
      `${endpoint.schoolMaster.bulkUpload}?offset=${page}&pageSize=50`,
      payload,
      "post"
    );

    setIsLoading(false);
    if (response?.code === 200) {
      const { totalRecords, bulkUploadLogResponseList } = response.data;
      setRowCount(totalRecords);
      setRows(bulkUploadLogResponseList);
    } else {
      setRowCount(0);
      setRows([]);
    }
  };

  const searchHandler = (filters) => {
    fetchBulkSchoolUploadLog(filters, 0);
    setCurrentPage(0);
  };

  const onPageChange = (page) => {
    fetchBulkSchoolUploadLog(globalFilter, page);
    setCurrentPage(page);
  };

  const handleDownloadTemplate = async () => {
    const bulkSchoolTemplate = `${endpoint.templateUrl}?documentTypeDisplayValue=${DOC_DISPLAY_VALUE}&serviceType=${SERVICE_NAME}`;
    const downloadUrl = endpoint.fetchS3Url.getDownloadUrl;

    setIsLoading(true);

    try {
      const resp = await fetchAllPromisedData(bulkSchoolTemplate, true);
      if (resp?.code === 200)
        putpost(
          `${downloadUrl}?key=${resp?.data?.["Template Url"]}`,
          (data) => {
            if (data.code === 200 && data.data) {
              window.open(`${data.data.url}`);
              setIsLoading(false);
            } else {
              setIsLoading(false);
              setInfoModalOpen(true);
              // failureToast(data.message)
            }
          },
          (data) => {
            setIsLoading(false);
            setInfoModalOpen(true);
            // failureToast(data["message"]);
          },
          {},
          "post"
        );
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const saveHandler = async (fileData) => {
    setUploadDialogOpen(false);

    const { s3Key, fileName, processId } = fileData;

    setFileUploadData({
      bulkUploadS3Key: s3Key,
      fileName: fileName,
    });

    const reqObj = {
      courseFeesProcessingDTO: {
        key: s3Key,
        fileName: fileName,
        status: "ACTIVE",
        processInstanceId: processId,
        description: `user uploaded bulk school master file - ${processId}`,
      },

      isProcess: true,
      serviceName: SERVICE_NAME,
      processId: processId,
    };

    const resp = await fetchAllPostPromisedData(
      endpoint.fetchS3Url.updateToServer,
      reqObj,
      "post"
    );
    if (resp?.code === 200) {
      setFileUploadData({
        bulkUploadS3Key: "",
        fileName: "",
      });
      onPageChange(0);
    } else failureToast("Something went wrong please try after sometime.");
  };

  return (
    <div>
      <>
        <Card className="m-3 p-4">
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <BackArrow
                className="mr-2 cursor"
                onClick={() => history.goBack()}
              />
              <span className="d-inline text-dark text-bold">
                Bulk upload schools
              </span>
            </div>

            <div className="d-flex">
              <APopover
                buttonComponent={(openPopover, styles) => (
                  <AButton
                    className="tiny-semi-bold color-dark"
                    onClick={openPopover}
                    size="xs"
                    updatedStyle={{
                      minWidth: "61px",
                      ...(filterCount > 0
                        ? {
                            border: "1px solid #00B0F5",
                            color: "#00B0F5",
                          }
                        : styles),
                    }}
                  >
                    Filters {filterCount > 0 ? `(${filterCount})` : ""}
                  </AButton>
                )}
                menuComponent={(closePopup) => (
                  <Filters
                    closeForm={closePopup}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    filterCount={filterCount}
                    setFilterCount={setFilterCount}
                    searchHandler={searchHandler}
                  />
                )}
              />

              <AButton
                className="tiny-semi-bold color-dark"
                onClick={() => handleDownloadTemplate()}
                size="xs"
                updatedStyle={{
                  minWidth: "61px",
                  border: "1px solid #262626",
                }}
              >
                <span
                  className="d-flex justify-content-center align-items-center"
                  style={{ gap: "10px" }}
                >
                  <DownloadIcon /> Download bulk school template
                </span>
              </AButton>

              <AButton
                className="tiny-semi-bold color-dark"
                onClick={() => {
                  setUploadDialogOpen(true);
                }}
                size="xs"
                updatedStyle={{
                  minWidth: "61px",
                }}
                variant="primary_filled"
              >
                <span
                  className="d-flex justify-content-center align-items-center"
                  style={{ gap: "10px" }}
                >
                  <UploadIcon /> Upload school bulk file
                </span>
              </AButton>
            </div>
          </div>

          {/* table rows */}
          <TableContent
            rows={rows}
            rowCount={rowCount}
            isLoading={isLoading}
            currentPage={currentPage}
            onPageChange={onPageChange}
          />
        </Card>

        {isUploadDialogOpen && (
          <DocUploadModal
            open={isUploadDialogOpen}
            setOpen={setUploadDialogOpen}
            saveHandler={(a, b, fileData) => saveHandler(fileData)}
            acceptedFileTypes={[".xls", ".csv"]}
            maxUploadFileSize={5}
            serviceName={SERVICE_NAME}
            uniqueKeyParameter={"bulkSchoolFile"}
            uploadedFileS3Key={fileUploadData?.bulkUploadS3Key}
            uploadedFileName={fileUploadData?.fileName}
            modalTitle={"Upload school file"}
            propStyle={{ overflow: "auto", maxWidth: "325px" }}
            fileTypeErrorMsg={
              'Invalid file format. Please upload a .xls or .csv file."'
            }
            fileSizeErrorMsg={
              "File size exceeds 5 MB. Please upload a smaller file."
            }
          />
        )}
      </>

      <ConfirmationDialog
        type="info"
        msg={commonMessages.pricingErrorFileNotGenerated}
        setIsOpen={setInfoModalOpen}
        isOpen={isInfoModalOpen}
        headerMsg={"Info"}
        popupSymbol="!"
      />

      {isLoading && (
        <Backdrop
          open={isLoading}
          sx={(theme) => ({
            color: "#fff",
            zIndex: 1300,
          })}
        >
          <ALoader />
        </Backdrop>
      )}
    </div>
  );
};

export default BulkSchoolUpload;
